module.exports = __webpack_public_path__ + "img/lucas_pf.d28efa68.jpg";